<template>
	<el-tabs class="main-tab-pane" v-model="currentPage" type="card" @tab-click="changeTab" closable @tab-remove="removeTab">
		<el-tab-pane v-for="(item, index) in tabs" :key="index" :label="item.label" :name="item.tag">
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	export default {
		data() {
			return {
				currentPage: '',
				tabs: [],
			}
		},
		created() {
			let obj = this.$store.state.common.tabObjs['home']
			this.currentPage = obj.tag||obj.name
			this.tabs = this.$store.state.common.tabObjs
			this.$router.push({
				name: this.currentPage,
				params: {
					label: this.currentPage,
					name: this.currentPage
				}
			})
		},
		computed: {
			currentTabPage() {
				return this.$store.state.common.currentTabPage
			},
		},
		watch: {
			currentTabPage: {
				handler(a, b) {
					this.tabs = {}
					this.tabs = this.$store.state.common.tabObjs
					this.currentPage = a.currentTab.tag||a.currentTab.name
				},
				deep: true
			}
		},
		methods: {
			//移除标签
			removeTab(targetName, obj) {
				
				/**
				 * 删除toptab，
				 * 需要设置tabs的总数组，包括vuex
				 * 如果关闭的页面为当前页，需要设置当前页面的tab，包括vuex
				 */
				//需要传给路由的对象
				let needTab = {},
					delTab = {},
					lastTab = {},
					tabs = window.Shendufuzhi(this.tabs),
					needName = ''
				/**
				 * 有obj对象的存在是外面传入的
				 * 如果传了需要跳转的页面，
				 * 那么直接关闭当前页面
				 */
				this.$router.history.current.meta.keepAlive = false
				if(obj) {
					
					if(window.Panduanxx(obj) === 'string') {
						needName = obj
					} else {
						needName = obj.param.url||obj.param.name||obj.param.tag
					}
					//删除当前页面
					let tag = this.$store.state.common.currentTabPage.currentTab.tag
					
					delete tabs[tag]

					if(needName && needName in tabs) {
						this.toRoute(tabs[needName])
					} else {
						//如果页面已经关闭了tabs不存在，则新打开一个
						if(window.Panduanxx(obj) === 'string') {
							let pp = this.$store.state.common.allPath
							this.openNewTab(pp[obj])
						} else {
							this.toRoute(obj)
						}
						return
					}
				}
				for(let idx in tabs) {
					//targetName为需要删除的页面
					if(tabs[idx].tag == targetName) {
						delTab = tabs[idx]
						/**
						 * 如果外面没有指定needName
						 * 则默认使用上一个页面
						 * 点击叉叉组件内调用
						 */
						if(!needName) {
							needTab = lastTab
						}
						delete tabs[idx]
					}
					lastTab = tabs[idx]
				}
				//更新tabs
				this.tabs = {}
				this.$store.state.common.tabObjs = this.tabs = tabs
				//再判断关闭的页面是否为当前页面，是的话就需要跳转到对应页
				if(delTab.tag == this.$store.state.common.currentTabPage.currentTab.tag) {
					//如果跳转的是同一个页面(name相同，tag不同，name不同，tag页不同)
					this.toRoute(needTab)
				}
			},
			/**
			 * 直接点击切换标签
			 * tab点击chang事件直接由tab驱动，需要跳转到对应的路由
			 * 更新全局的currentTabPage
			 */
			changeTab(tab, e) {
				//如果跳转的是同一个页面(name相同，tag不同，name不同，tag页不同)
				if(this.$store.state.common.currentTabPage.currentTab.tag !== tab.name) {
					let needTab = this.getCurrentTab(tab.name)
					this.toRoute(needTab)
				}
			},
			getCurrentTab(targetName) {
				let tabs = this.tabs
				for(let idx in tabs) {
					if(tabs[idx].tag == targetName) {
						return tabs[idx]
					}
				}
			},
			toRoute(needTab) {
				// this.$router.history.current.meta.keepAlive = true
				if(needTab) {
					this.$store.dispatch('changeTopTab', needTab);
					this.$router.replace({
						name: needTab.name,
						params: needTab.param
					})
				}
			},
		}
	}
</script>

<style lang="scss">
	.main-tab-pane {
		.el-tabs__nav .el-tabs__item:nth-child(1) span {
			display: none;
		}
		.el-tabs__header {
			margin: 0;
		}
		.el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable {
			padding-left: 20px;
			padding-right: 0;
		}
		.el-tabs__item {
			padding-right: 8px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/globle/tabs.vue